import { observer } from 'mobx-react-lite';
import { Switch, Typography } from '@web-chat-core/ui-kit';
import { useTranslation } from 'react-i18next';
import { Modal } from 'features/Modals';
import { getWebinarMode, isWebinarEnabled } from 'useCase/webinar/webinarStatus';
import { useApplyWebinarMode } from '../../hooks/useApplyWebinarMode';
import { SettingsContent, ToggleDescription, ToggleInfo, ToggleLabel, ToggleRow, ToggleRowHeader } from './view';

export const WebinarModeModal = observer(() => {
    const { t } = useTranslation();
    const { applyWebinarMode } = useApplyWebinarMode();

    const webinarMode = getWebinarMode();
    const enabled = isWebinarEnabled();
    const microDisabled = Boolean(webinarMode?.microDisabled);
    const cameraDisabled = Boolean(webinarMode?.cameraDisabled);
    const screenShareDisabled = Boolean(webinarMode?.screenShareDisabled);

    return (
        <Modal header={<Typography variant="body1">{t('vks_webinar_mode_title')}</Typography>}>
            <SettingsContent>
                <ToggleRow>
                    <ToggleRowHeader>
                        <ToggleInfo>
                            <ToggleLabel variant="body5">{t('vks_webinar_mode_title')}</ToggleLabel>
                        </ToggleInfo>
                        <Switch checked={enabled} onChange={(e) => applyWebinarMode({ enabled: e.target.checked })} />
                    </ToggleRowHeader>
                    <ToggleDescription variant="body3">{t('vks_webinar_mode_description')}</ToggleDescription>
                </ToggleRow>

                <ToggleRow>
                    <ToggleRowHeader>
                        <ToggleInfo>
                            <ToggleLabel variant="body5">{t('vks_webinar_disable_mic_all')}</ToggleLabel>
                        </ToggleInfo>
                        <Switch
                            checked={microDisabled}
                            disabled={!enabled}
                            onChange={(e) => applyWebinarMode({ microDisabled: e.target.checked })}
                        />
                    </ToggleRowHeader>
                    <ToggleDescription variant="body3">
                        {t('vks_webinar_mode_microphones_note_description')}
                    </ToggleDescription>
                </ToggleRow>

                <ToggleRow>
                    <ToggleRowHeader>
                        <ToggleInfo>
                            <ToggleLabel variant="body5">{t('vks_webinar_disable_video_all')}</ToggleLabel>
                        </ToggleInfo>
                        <Switch
                            checked={cameraDisabled}
                            disabled={!enabled}
                            onChange={(e) => applyWebinarMode({ cameraDisabled: e.target.checked })}
                        />
                    </ToggleRowHeader>
                    <ToggleDescription variant="body3">
                        {t('vks_webinar_mode_cameras_note_description')}
                    </ToggleDescription>
                </ToggleRow>

                <ToggleRow>
                    <ToggleRowHeader>
                        <ToggleInfo>
                            <ToggleLabel variant="body5">{t('vks_webinar_disable_screen_share')}</ToggleLabel>
                        </ToggleInfo>
                        <Switch
                            checked={screenShareDisabled}
                            disabled={!enabled}
                            onChange={(e) => applyWebinarMode({ screenShareDisabled: e.target.checked })}
                        />
                    </ToggleRowHeader>
                    <ToggleDescription variant="body3">{t('vks_webinar_screen_share_view_only')}</ToggleDescription>
                </ToggleRow>
            </SettingsContent>
        </Modal>
    );
});
